import { createSlice, PayloadAction } from "@reduxjs/toolkit";
 
interface User {
  id?: number;
  name?: string;
  phoneNumber?: string;
}
 
interface AuthState {
  token: string | null;
  user: User | null;
  isLoggedIn: boolean;
}
 
const initialState: AuthState = {
  token: localStorage.getItem("token") || null,
  user: localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user") as string)
    : null,
  isLoggedIn: !!localStorage.getItem("token"),
};
 
const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLogin: (
      state,
      action: PayloadAction<{ token: string; user: User }>
    ) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.isLoggedIn = true;
 
      // persist
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("user", JSON.stringify(action.payload.user));
    },
 
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.isLoggedIn = false;
 
      localStorage.clear();
    },
  },
});
 
export const { setLogin, logout } = AuthSlice.actions;
export default AuthSlice.reducer;